import React, { useEffect, useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Box,
  Button,
  Card,
  CardContent,
  Collapse,
  Stack,
} from '@mui/material';

function readInitialExpanded(storageKey, defaultExpanded) {
  if (!storageKey || typeof window === 'undefined') {
    return defaultExpanded;
  }

  try {
    const storedValue = window.localStorage.getItem(storageKey);
    if (storedValue == null) {
      return defaultExpanded;
    }

    return storedValue !== 'false';
  } catch {
    return defaultExpanded;
  }
}

function CollapsibleModuleHeaderCard({
  storageKey,
  defaultExpanded = true,
  summary,
  children,
  sx,
  collapseLabel = 'Kopfzeile ausblenden',
  expandLabel = 'Kopfzeile einblenden',
}) {
  const [expanded, setExpanded] = useState(() => readInitialExpanded(storageKey, defaultExpanded));

  useEffect(() => {
    if (!storageKey || typeof window === 'undefined') {
      return;
    }

    try {
      window.localStorage.setItem(storageKey, expanded ? 'true' : 'false');
    } catch {
      // Ignore storage write failures.
    }
  }, [expanded, storageKey]);

  return (
    <Card sx={sx}>
      <CardContent>
        <Stack spacing={expanded ? 1.25 : 0}>
          <Stack
            direction={{ xs: 'column', lg: 'row' }}
            spacing={1}
            justifyContent="space-between"
            alignItems={{ xs: 'stretch', lg: 'flex-start' }}
          >
            <Box sx={{ flex: 1, minWidth: 0 }}>
              {summary}
            </Box>
            <Button
              size="small"
              variant="text"
              onClick={() => setExpanded((currentValue) => !currentValue)}
              startIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              sx={{ alignSelf: { xs: 'stretch', lg: 'center' }, whiteSpace: 'nowrap' }}
            >
              {expanded ? collapseLabel : expandLabel}
            </Button>
          </Stack>

          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box sx={{ pt: 0.5 }}>
              {children}
            </Box>
          </Collapse>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default CollapsibleModuleHeaderCard;